import { Box, Flex, Spinner } from "@chakra-ui/react";
import Fade from "src/components/Fade";

function CenteredFade({ in: inProp, children }) {
  return (
    <Fade
      in={inProp}
      duration={{
        enter: 0.3,
        exit: 0
      }}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        position="absolute"
        top="0"
        left="0"
      >
        {children}
      </Flex>
    </Fade>
  );
}

export default function InsideCircularProgress({ status, stopRecording }) {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      position="absolute"
      top="0"
      left="0"
    >
      <Flex
        onClick={status === "recording" ? stopRecording : undefined}
        bg="white"
        position="relative"
        borderRadius="100%"
        width="44px"
        height="44px"
        transition="background 300ms"
        _hover={status === "recording" ? { bg: "#ebebeb" } : undefined}
        _active={status === "recording" ? { bg: "#cccccc" } : undefined}
      >
        <CenteredFade in={status === "recording"}>
          <Box p="7px" borderRadius="2px" bg="warningBase" />
        </CenteredFade>
        <CenteredFade
          in={
            status === "initial" ||
            status === "waitingForResponse" ||
            status === "waitingForThumbnail"
          }
        >
          <Spinner />
        </CenteredFade>
      </Flex>
    </Flex>
  );
}
